'use strict';

window.actionTrackings = window.actionTrackings || [];
var stj = typeof stj !== 'undefined' ? stj : {};

stj.connectivity = {
    isOnline: true,
    firstChange: true,

    registerConnectivityHandlers: function () {
        window.addEventListener('online', this.updateConnectivityStatus.bind(this));
        window.addEventListener('offline', this.updateConnectivityStatus.bind(this));
        window.addEventListener('usergoneonline', function() {
            this.hideOfflineMessage();
            this.trackConnectivityChange();
        }.bind(this));
        window.addEventListener('usergoneoffline', function (){
            this.showOfflineMessage();
            this.trackConnectivityChange();
        }.bind(this));
    },

    updateConnectivityStatus: function () {
        if (typeof navigator.onLine === 'undefined') {
            return;
        }

        this.isOnline = navigator.onLine;

        if (this.isOnline) {
            window.dispatchEvent(new Event('usergoneonline'));
        } else {
            window.dispatchEvent(new Event('usergoneoffline'));
        }
    },

    showOfflineMessage: function () {
        if (!document.getElementById('offlineNotice')) {
            return;
        }
        document.getElementById('offlineNotice').hidden = false;
    },

    hideOfflineMessage: function () {
        if (!document.getElementById('offlineNotice')) {
            return;
        }
        document.getElementById('offlineNotice').hidden = true;
    },

    trackConnectivityChange: function () {
        if (this.firstChange) {
            this.firstChange = false;
            return;
        }
        window.actionTrackings.push({
            acTrAc: 'connectivityChanged',
            acTrLa: this.isOnline ? 'online' : 'offline',
        });
    },
};

window.addEventListener('load', function() {
    stj.connectivity.registerConnectivityHandlers();
    stj.connectivity.updateConnectivityStatus();
});
